jQuery(function ($) {


  // let headerHeight = $("header").height();
  // let menuHeight = $("#wrap-logo").height();
  // let newMenuHeight = 0;
  // $(window).scroll(function () {
  //   if ($(window).scrollTop() > menuHeight) {
  //     $("header").css("height", headerHeight);
  //     newMenuHeight = $("#wrap-menu").height();

  //     $("#wrap-menu").addClass("sticky");
  //   } else if ($(window).scrollTop() <= (menuHeight - newMenuHeight)) {
  //     $("#wrap-menu").removeClass("sticky");
  //   }
  // });

  $('[name="mobile-nav"]').change(function () {
    if ($(this).is(":checked")) {
      let scrollPosition = [
        self.pageXOffset ||
          document.documentElement.scrollLeft ||
          document.body.scrollLeft,
        self.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop,
      ];
      let html = jQuery("body"); 
      html.data("scroll-position", scrollPosition);
      html.data("previous-overflow", html.css("overflow"));
      html.css("overflow", "hidden");
      window.scrollTo(scrollPosition[0], scrollPosition[1]);
      $('header').addClass('above')
    } else {
      let html = jQuery("body");
      let scrollPosition = html.data("scroll-position");
      html.css("overflow", html.data("previous-overflow"));
      window.scrollTo(scrollPosition[0], scrollPosition[1]);
      $('header').removeClass('above')
    }
  });
});
